const MODULE_NAME = "OTP";
const SEND_OTP_CODE_STARTED = MODULE_NAME + 'SEND_STARTED';
const SEND_OTP_CODE_COMPLETED = MODULE_NAME + 'SEND_COMPLETED';

export {
  SEND_OTP_CODE_COMPLETED,
  SEND_OTP_CODE_STARTED
};
